<div class="flex items-center justify-end mb-4 gap-4">
    @if (payoutPeriodOptionsLoading() || payoutPeriodOptions().length) {
        <div class="w-[20rem]">
            <sh-select
                [label]="'seasons.season-details.payout-periods.filter-placeholder' | translate"
                [multiSelect]="true"
                [disabled]="payoutPeriodOptionsLoading()"
                [options]="payoutPeriodSelectOptions()"
                [ngModel]="selectedPayoutPeriods()"
                (ngModelChange)="onPayoutPeriodFilterChange($event)"
            />
        </div>
    }
    <div class="w-[20rem]">
        <sh-select
            [label]="'seasons.season-details.statusFilterPlaceholder' | translate"
            [multiSelect]="true"
            [options]="statusOptions()"
            [ngModel]="selectedStatuses()"
            (ngModelChange)="onStatusFilterChange($event)"
        />
    </div>
    <div class="w-[20rem]">
        <sh-select
            [label]="'seasons.season-details.commentFilterPlaceholder' | translate"
            [options]="commentOptions()"
            [ngModel]="selectedCommentFilter()"
            (ngModelChange)="onCommentFilterChange($event)"
        />
    </div>
    <div class="w-[20rem]">
        <sh-input-text
            [label]="'seasons.season-details.search' | translate"
            [value]="filters()?.searchTerm ?? ''"
            (value-changed)="onSearchTermChange($event)"
        />
    </div>
</div>
